export default __webpack_public_path__ + "static/media/Svelte_Logo.57c1423f.svg";